import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1)
  },
  buttonGroup: {
    padding: theme.spacing(1, 0)
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 12,
    flexBasis: 0
  },
  scheduleButton: {
    fontSize: 10,
    border: 'none',
    background: 'none',
    color: theme.palette.grey.main
  },
  schedule: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  scheduleTable: {
    textAlign: 'center',
    padding: theme.spacing(1.5),
    background: theme.palette.grey.light
  },
  table: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(0.5)
  },
  tableCell: {
    flexGrow: 4,
    flexBasis: 80,
    padding: theme.spacing(1),
    borderRight: `1px solid ${theme.palette.blueGrey.light}`,
    fontSize: 10,
    '&:last-child': {
      borderRight: 'none'
    }
  },
  scheduleTitle: {
    fontSize: 12
  },
  tableAmount: {
    fontWeight: 600
  },
  buttonIcon: {
    width: 10,
    height: 10,
    display: 'inline-block',
    '&:after': {
      display: 'inline-block',
      position: 'relative',
      content: '""',
      top: -2,
      right: 0,
      marginRight: 4,
      width: 6,
      height: 6,
      transform: 'rotate(45deg)',
      borderRight: `1px solid ${theme.palette.grey.main}`,
      borderBottom: `1px solid ${theme.palette.grey.main}`,
      transition: '.2s',
    },
  },
  active: {
    '&:after': {
      transform: 'rotate(225deg)',
      top: 2,
    }
  }
}));

export default useStyles;
